import React from 'react'
import PropTypes from 'prop-types'

import { map } from 'lodash'

import { Box, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

import api from 'common/api'

import './index.scss'

class HighSchoolTypeahead extends React.Component {
  static propTypes = {
    onSelect: PropTypes.func.isRequired,
  }
  constructor(props) {
    super(props)
    this.state = {
      options: [],
      value: '',
      inputValue: '',
      open: false,
    }
  }

  onSearch(searchName) {
    api.get(`/api/high_schools/find/${searchName}`).then((highSchools) => {
      const options = map(highSchools, (hs) => ({
        Id: hs.value,
        Name: hs.tokens[0],
        City: hs.tokens[1],
        State: hs.tokens[2],
      }))

      this.setState({ options: options })
      return options
    })
  }
  render() {
    return (
      <div className="high-school-search-comp">
        <div className="search-input-container">
          <Autocomplete
            value={this.state.value}
            inputValue={this.state.inputValue}
            id="calander-hs-typeahead"
            options={this.state.options}
            label="Type a high school name, town, or zip"
            onChange={(e, selection, reason) => {
              if (reason === 'select-option') {
                this.props.onSelect(selection)
              }
            }}
            noOptionsText="No matches found."
            onInputChange={(e, val) => {
              this.setState({ inputValue: val })

              if (val.length === 0) {
                this.setState({ options: [] })
              } else {
                this.onSearch(val)
              }
            }}
            freeSolo
            clearOnBlur
            blurOnSelect
            getOptionLabel={(option) => option.Name || ''}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Enter high school name"
                variant="outlined"
              />
            )}
            renderOption={(item) => {
              return (
                <Box>
                  <Typography>
                    <strong>{item.Name}</strong>
                  </Typography>
                  <Typography>{`${item.City}, ${item.State}`}</Typography>
                </Box>
              )
            }}
            closeIcon={null}
            open={this.state.open}
            onOpen={() => {
              if (this.state.inputValue.length > 0 && this.state.options.length > 0) {
                this.setState({ open: true })
              }
            }}
            onClose={() => {
              this.setState({ open: false, inputValue: '', value: '', options: [] })
            }}
          />
        </div>
      </div>
    )
  }
}

export default HighSchoolTypeahead
